// track the task status of the import

import { createContext, useState } from 'react';

type TaskStatusContextType = {
  taskStatusPercent: number;
  isTaskStatusLoading: boolean;
  setTaskStatusPercent: (percent: number) => void;
  setIsTaskStatusLoading: (loading: boolean) => void;
};

export const TaskStatusContext = createContext<TaskStatusContextType>({
  taskStatusPercent: 0,
  isTaskStatusLoading: false,
  setTaskStatusPercent: () => undefined,
  setIsTaskStatusLoading: () => undefined,
});

export const TaskStatusProvider = ({ children }: { children: React.ReactNode }) => {
  const [taskStatusPercent, setTaskStatusPercent] = useState(0);
  const [isTaskStatusLoading, setIsTaskStatusLoading] = useState(false);

  return (
    <TaskStatusContext.Provider
      value={{
        taskStatusPercent,
        isTaskStatusLoading,
        setTaskStatusPercent,
        setIsTaskStatusLoading,
      }}
    >
      {children}
    </TaskStatusContext.Provider>
  );
};
